let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iseQf")).then(() => parcelRequire('dKu0d'));